// Polaris (fase 5.3, Q4): a contact is a drawer over its list, so every list view has an "open contact" twin and
// the page is one component for both. These are the pairs, and the two ways across: open (list → the same view with
// the drawer) and close (the drawer → the same view, same query: page, search).
export const LIST_OF = {
  contacts_edit: 'contacts_dashboard_index',
  contacts_edit_segment: 'contacts_dashboard_segments_index',
  contacts_edit_label: 'contacts_dashboard_labels_index',
  contacts_edit_active: 'contacts_dashboard_active',
};

export const EDIT_OF = Object.fromEntries(
  Object.entries(LIST_OF).map(([edit, list]) => [list, edit])
);

// The params a list view needs (the segment or the label), without the contact.
const viewParams = ({ accountId, segmentId, label }) => ({
  accountId,
  ...(segmentId !== undefined && { segmentId }),
  ...(label !== undefined && { label }),
});

export const isContactRoute = route => route.name in LIST_OF;

export const listRouteOf = route => ({
  name: LIST_OF[route.name] || route.name,
  params: viewParams(route.params),
  query: route.query,
});

export const contactRouteOf = (route, contactId) => ({
  name: EDIT_OF[LIST_OF[route.name] || route.name] || 'contacts_edit',
  params: { ...viewParams(route.params), contactId },
  query: route.query,
});
